/** This is a document navigation, not a JSON API read. The backend owns the
 * OAuth 1.0a exchange, request-token secrets, wallet binding and final redirect. */
export function xOAuthCallbackDestination(search: string, baseUrl: string, origin: string): string | null {
  const parameters = new URLSearchParams(search);
  const one = (name: string) => parameters.getAll(name).length === 1 && !!parameters.get(name)?.trim();
  const success = parameters.size === 2 && one("oauth_token") && one("oauth_verifier");
  const denied = parameters.size === 1 && one("denied");
  if (!success && !denied) return null;
  try {
    const base = new URL(`${(baseUrl.trim() || "/api").replace(/\/$/, "")}/x/oauth/callback`, origin);
    if (!["http:", "https:"].includes(base.protocol) || base.username || base.password || base.search || base.hash ||
      base.origin === origin && base.pathname === "/x/oauth/callback") return null;
    // Preserve the provider query exactly; never decode/re-encode or log credentials.
    base.search = search;
    return base.href;
  } catch { return null; }
}
